<h3 class="textPrimaryColor text-2xl font-bold" i18n="@@breadcrumbAddBankAccount">Add Bank Account</h3>

<app-create-bank-account />
